import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ssApiService } from 'app/services/ss-api.service';
import Swal from 'sweetalert2';
import { GlobalServices } from '../../services/global.service';
import { TrainingEvent } from '../../models/domain/training.event';
import { TrainingCalendarRequest } from 'app/models/ss-api/requests/training.calendar.request';
import { TrainingClass } from 'app/models/domain/training.class';
import { TrainingHistoryResponse } from 'app/models/ss-api/responses/training.history.response';
import { EventRegistrationDialogComponent } from '../event-registration/event-registration-dialog.component';
import { UpdateTrainingEventSubscriptionStatusRequest } from 'app/models/ss-api/requests/update.training.event.subscription.status.request';
import { AttendanceStatusTypes } from 'app/models/domain/training.event.subscription';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IEventRescheduleDialogModel {
    Event: TrainingHistoryResponse;
    LicenseID: number;
}

class CalendarEvent {
    title: String;
    start: Date;
    end: Date;
    event: TrainingEvent;
}

@Component({
  selector: 'event-reschedule-dialog',
  styleUrls: ['./event-reschedule-dialog.component.css'],
  templateUrl: './event-reschedule-dialog.component.html'
})

export class EventRescheduleDialogComponent implements OnInit {
    Events: Array<CalendarEvent>;
    Event: TrainingHistoryResponse;
    MinimumTrainingVersionv2: string;
    MinimumTrainingVersionv3: string;
    CurrentTrainingVersion: string;

    isBusy: boolean = true;

    constructor(
        private dialogService: DialogService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private api: ssApiService, private gb: GlobalServices) {
    }

    ngOnInit() {
        this.Event = this.config.data.Event;

        this.LoadEvents();
    }

    close() {
        this.ref.close();
    }

    LoadEvents() {
        let request: TrainingCalendarRequest = new TrainingCalendarRequest();
        let tempEvents = [];
        request.StartDate = moment().toDate();
        request.EndDate = moment().add(30, 'days').toDate();

        let disposable = this.api.GetMemberTrainingCalendar(request).subscribe(response => {
            this.MinimumTrainingVersionv2 = response.Data.TrainingMinimumSoftwareVersionv2;
            this.MinimumTrainingVersionv3 = response.Data.TrainingMinimumSoftwareVersionv3;
            this.CurrentTrainingVersion = response.Data.CurrentSoftwareVersion;

            response.Data['TrainingEvents'].forEach(function(e: TrainingEvent) {
                let trainingClass: TrainingClass = response.Data['TrainingClasses'].filter(c => c.ID == e.TrainingClassID)[0];
                if (e.ID != this.Event.EventID && trainingClass.ProductIDs.indexOf(this.Event.Product_ID) >= 0) {
                    let duration = moment(trainingClass.ClassDuration, 'hh:mm:ss');
                    let eventTemplate: CalendarEvent = new CalendarEvent();

                    eventTemplate.title = trainingClass.ClassTitle;
                    eventTemplate.start = new Date(e.EventDateTime);
                    eventTemplate.end = moment(e.EventDateTime).add({hours: duration.hours(), minutes: duration.minutes()}).toDate();
                    eventTemplate.event = e;
                    eventTemplate.event.TrainingClass = trainingClass;

                    tempEvents.push(eventTemplate);
                }
            }, this);

            this.Events = tempEvents;
            this.isBusy = false;

            disposable.unsubscribe();
        });
    }

    RegisterForClass(event: TrainingEvent) {
        if (moment().isAfter(moment(this.Event.EventDateTime).subtract(15, 'minutes'))) {
            Swal.fire({
                icon: 'error',
                title: 'Class Closed',
                text: 'Open registration for this class is now closed. Please select a different class.'
            });
        } else {
            this.dialogService.open(EventRegistrationDialogComponent, {data: {
                title: 'Test Title',
                subTitle: 'Another Test',
                event: event,
                minimumVersionv2: this.MinimumTrainingVersionv2,
                minimumVersionv3: this.MinimumTrainingVersionv3,
                currentVersion: this.CurrentTrainingVersion,
                licenseID: this.Event.License_ID
            }});
            this.isBusy = true;
            let request = new UpdateTrainingEventSubscriptionStatusRequest();
            request.AttendanceStatusType = AttendanceStatusTypes.Rescheduled;
            request.TrainingEventSubscriptionID = Number(this.Event.TrainingEventSubscriptionID);
            let disposable = this.api.UpdateTrainingEventSubscriptionStatus(request).subscribe(r => {
                Swal.fire({
                    icon: 'success',
                    title: 'Successfully Rescheduled',
                    text: 'You have rescheduled to a new class. Please check your email for your registration confirmation.'
                }).then(() => {
                    this.close();
                });
                disposable.unsubscribe();
            });
        }
    }

    TrainingEventForEvent(event: TrainingEvent): TrainingEvent {
        let trainingEvent: TrainingEvent;

        this.Events.forEach(function(training) {
            if (training.event.ID == event.ID) {
                trainingEvent = training.event;
            }
        });

        return trainingEvent;
    }

    ProductsForEvent(event: TrainingEvent) {
        let productHTML = '';
        let productBorder = '';

        event.TrainingClass.ProductIDs.forEach(function(product) {
            let icon = '';
            let color = '#000';
            switch (product) {
                case 5:
                    icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                    color = '#0064DF';
                    break;
                case 8:
                    icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                    color = '#FF0000';
                    break;
                case 9:
                    icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                    color = '#64A000';
                    break;
                default:
                    return false;
            }
            productHTML += '<img class="event-software-icon" style="border-color: ' + color + '" src="' + icon + '" />';
            productBorder += '<div class="event-product-section" style="background-color: ' + color + '"></div>';
        }, this);

        return {
            ProductIcons : productHTML,
            ProductBorder: productBorder
        };
    }

}
